import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import styled from 'styled-components';

import downArrowIcon from '@/assets/common/downArrow.png';
import { ProductTypeList } from '@/constants/supply';
import { useAppSelector } from '@/hooks/useReduxHooks';
import { useDispatch } from 'react-redux';
import { dropListState } from '@/store/modules/refund';

interface IProps {
  name: string;
  index: number;
}

interface IDropList {
  key: number;
  value: string;
}

interface IProductType {
  key: number;
  value: string;
  name: string;
}

function SelectBox({ name, index }: IProps) {
  const [selectValue, setSelectValue] = useState('');
  const methods = useFormContext();
  const { productTypes, hospitalId } = useAppSelector<any>(
    (state) => state.user,
  );
  const { temporaryStorage } = useAppSelector<any>((state) => state.refund);
  const { isStorageModal } = useAppSelector<any>((state) => state.validate);

  const [medicalTypeList, setMedicalTypeList] = useState<
    IDropList[] | undefined
  >([]);

  const { isDropList } = useAppSelector((state) => state.refund);
  const { isKioskRefundModal } = useAppSelector((state) => state.validate);
  const dispatch = useDispatch();

  // 임시저장 값 불러오기
  useEffect(() => {
    if (temporaryStorage.supplyDate) {
      let isValue = false;
      ProductTypeList.forEach((type) => {
        if (temporaryStorage.supply[index]?.productType === type.key) {
          setSelectValue(type.value);
          methods.setValue(name, type.key);
          isValue = true;
        }
        if (!isValue) {
          setSelectValue('');
          methods.setValue(name, '');
        }
      });
    }
  }, [temporaryStorage]);

  const onMouseDown = (dropList: IDropList) => {
    setSelectValue(dropList.value);
    dispatch(dropListState({ isDrop: false, index }));
    methods.setValue(name, dropList.key);
  };

  // 시술명 초기화
  useEffect(() => {
    if (!String(methods.getValues(name)) && !isStorageModal) {
      setSelectValue('');
    } else {
      const type = methods.getValues(`supply.${index}.productType`);
      setSelectValue(ProductTypeList[type]?.value);
    }
  }, [methods]);

  useEffect(() => {
    let newArray: IProductType[] = [];

    if (productTypes.length === 0) {
      setMedicalTypeList(ProductTypeList);
      return;
    }

    productTypes.map((productType: string) => {
      const result = ProductTypeList.find(
        (product) => String(product.key) === String(productType),
      );
      if (result) {
        newArray = [...newArray, result];
      }
    });

    if (
      hospitalId === 138 ||
      hospitalId === 1 ||
      hospitalId === 126 ||
      hospitalId === 156
    ) {
      newArray = [
        ProductTypeList[14],
        ...newArray.filter((item) => item.key !== 14),
      ];
    }

    setMedicalTypeList(newArray);
  }, []);

  useEffect(() => {
    const item = methods.getValues(`supply.${index}.productType`);
    if (item !== '') {
      setSelectValue(ProductTypeList[item].value);
    }
  }, [isKioskRefundModal]);

  return (
    <Container>
      <DropContainer
        onClick={() =>
          dispatch(dropListState({ isDrop: !isDropList[index].isDrop, index }))
        }
        onBlur={() => dispatch(dropListState({ isDrop: false, index }))}
      >
        <Select {...methods.register(name)} isDisplay />
        <Select
          value={selectValue}
          placeholder='시술명'
          readOnly
          isSelect={selectValue}
        />
        {<Image src={downArrowIcon} />}
      </DropContainer>
      {
        <DropList isDrop={isDropList[index]?.isDrop}>
          {medicalTypeList &&
            medicalTypeList.map((option) => (
              <DropItem
                key={option.key}
                onMouseDown={() => onMouseDown(option)}
              >
                <Text>{option.value}</Text>
              </DropItem>
            ))}
        </DropList>
      }
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 85%;
  text-align: center;
`;

const DropContainer = styled.div`
  display: flex;
  align-items: center;
  height: 32px;
  position: relative;
`;

const Select = styled.input<{ isSelect?: string; isDisplay?: boolean }>`
  display: ${(props) => (props.isDisplay ? 'none' : 'flex')};
  align-items: center;
  font-size: ${(props) => props.theme.fontSize.xSmall};
  text-align: center;
  cursor: pointer;
  color: ${(props) => props.isSelect && props.theme.blue[100]};
  background-color: ${(props) => (props.isSelect ? 'none' : 'transparent')};
  border: none;
  ::placeholder {
    color: ${(props) => props.theme.grayColors.scale3};
    text-align: center;
  }
`;

const Text = styled.span<{ isValue?: string }>`
  color: ${(props) =>
    props.isValue ? props.theme.blue[100] : props.theme.grayColors.scale3};
`;

const Image = styled.img`
  width: 16px;
  height: 16px;
  cursor: pointer;
`;

const DropList = styled.ul<{ isDrop: boolean }>`
  position: absolute;
  top: 35px;
  padding: 20px 16px;
  width: 110%;
  max-height: 170px;
  border-radius: 12px;
  overflow-y: auto;
  flex-direction: column;
  z-index: 10;
  display: ${(props) => (props.isDrop ? 'flex' : 'none')};
  border: 1px solid ${(props) => props.theme.mono[10]};
  background-color: ${(props) => props.theme.pointColors.white};
`;

const DropItem = styled.li`
  cursor: pointer;
  padding: 5px 0;
  background-color: #ffffff;
  :hover {
    background-color: ${(props) => props.theme.blue[5]};
    span {
      color: ${(props) => props.theme.blue[100]};
    }
  }
`;

export default SelectBox;
